module.exports = __webpack_public_path__ + "static/img/free-bg.6db3957.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xmasSaled-2025/free-bg.png
// module id = QW7Q
// module chunks = 1